import React from "react";
import { ElementGroup } from '@whalecloud/page-builder-core/constant';
import RangePicker from "./components/RangePicker";
import RangePickerSettings from "./components/RangePickerSettings";
import { ReactComponent as PluginSvg } from "@assets/icons/range_picker_setting.svg";
import { getLocale, defaultTarget } from '@utils/util';

export default () => {
  const messages = getLocale();
  return {
    name: 'rangePicker',
    group: ElementGroup.SELECT,
    target: defaultTarget,
    title: messages['PAGEBUIDER_ELEMENT_FORM_RANGEPICKER'],
    toolBarPreview: <PluginSvg />,
    data: {
      formItemSettings: {
        allowEmpty: [false, false],
        showTime: false
      },
      formSettings: {
        label: messages['PAGEBUIDER_ELEMENT_FORM_RANGEPICKER']
      },
      settings: {
        width: {
          value: "100%"
        },
      }
    },
    pluginComponent: RangePicker, // 插件渲染组件
    pluginSettingComponent: RangePickerSettings, // 插件设置项组件
  }
}
